
import { defineComponent } from "vue";

import ActionButton from "../Shared/ActionButton/ActionButton.vue";

export default defineComponent({
  name: "Intro",
  components: {
    ActionButton,
  },
  setup() {
    const scrollToWork = () => {
      document.getElementById("selected-work")?.scrollIntoView({
        behavior: "smooth",
      });
    };

    return {
      scrollToWork,
    };
  },
});
